import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { name: "pantry-camera-check-bottom-view" }
const _hoisted_2 = { class: "pantry-camera-check-bottom-view-area" }
const _hoisted_3 = { class: "pantry-camera-check-bottom-view-item" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "pantry-camera-check-bottom-view-item-text" }, "戻る", -1)
const _hoisted_5 = { class: "pantry-camera-check-bottom-view-item-position-text" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "pantry-camera-check-bottom-view-item-text" }, "スキップ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: "pantry-camera-check-bottom-view-item-text-left-area",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickBack(...args))),
          style: _ctx.styleBackButton
        }, [
          _hoisted_4
        ], 4),
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.getPosition()), 1),
        _createVNode("div", {
          class: "pantry-camera-check-bottom-view-item-text-right-area",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickSkip(...args)))
        }, [
          _hoisted_6
        ])
      ])
    ])
  ]))
}